import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { AddToBasketResponse } from 'components/ordering/add-to-basket/basket-parser.js'

export interface SelectedBasketOption {
  id: number
  quantity: number
}


export interface ProductToAdd {
  product: number
  quantity: number
  options: SelectedBasketOption[]
}


export interface AddToBasketApi {
  add: (request: AddProductRequest) => Promise<AddToBasketResponse>
}


export class AddProductRequest {
  endpointUrl: URL
  body: FormData
  method = 'POST' as const
  headers: HeadersInit = {
    'Accept': 'application/json',
  }

  constructor(endpoint: string, productToAdd: ProductToAdd) {
    this.endpointUrl = new URL(endpoint, window.location.href)
    this.body = new FormData()
    this.body.append('product', String(productToAdd.product))
    this.body.append('quantity', String(productToAdd.quantity))

    this.body.append('options', JSON.stringify(productToAdd.options))
  }
}


export const ADD_TO_BASKET_API = Symbol('ADD_TO_BASKET_API')


@registerDependency(FAKE, ADD_TO_BASKET_API)
export class FakeAddToBasketApi implements AddToBasketApi {
  response: Promise<AddToBasketResponse> = Promise.resolve({ statusCode: 500 })
  responsesByProductId: Map<number, Promise<AddToBasketResponse>> = new Map()
  requests: AddProductRequest[] = []

  add = (request: AddProductRequest): Promise<AddToBasketResponse> => {
    this.requests.push(request)
    const productId = Number(request.body.get('product'))
    return this.responsesByProductId.get(productId) ?? this.response
  }
}


@registerDependency(REAL, ADD_TO_BASKET_API)
export class RealAddToBasketApi implements AddToBasketApi {
  add = async (request: AddProductRequest): Promise<AddToBasketResponse> => {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers,
      body: request.body,
    })

    return {
      statusCode: response.status,
      body: await response.json()
    }
  }
}
